import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/** How much of the holder's name fits on the card before it has to be cut. */
const MAX_HOLDER_NAME_LENGTH = 19;

@Component({
  selector: 'app-fancy-card',
  templateUrl: './fancy-card.component.html',
  styleUrls: ['./fancy-card.component.css']
})
export class FancyCardComponent implements OnChanges {

  @Input() showHolderName: boolean;
  @Input() holderName: string;
  @Input() cardExpiration: string;
  @Input() cardBin: string;
  @Input() paymentMethodId: string;

  cardNumber: string = 'XXXX XXXX XXXX XXXX';
  expiration: string;
  displayHolderName: string = '';

  constructor(private translate: TranslateService) {
    this.expiration = this.expirationMask();
  }

  /**
   * The expiry placeholder, e.g. `MM/AA`. It reads as a date format to the user, so it is
   * translated: the year is `AA` in Spanish and `YY` in English.
   */
  private expirationMask(): string {
    return this.translate.instant('components.fancy_card.expiration_placeholder');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.holderName) {
      const name: string = changes.holderName.currentValue || '';
      this.displayHolderName = name.length > MAX_HOLDER_NAME_LENGTH
        ? name.substring(0, MAX_HOLDER_NAME_LENGTH - 1) + '…'
        : name;
    }

    // The issuer only ever gives us the first six digits; the rest of the card is masked. `X` is
    // the mask either way, so unlike the expiry it needs no translation.
    if (changes.cardBin) {
      const bin: string = (changes.cardBin.currentValue || '').padEnd(6, 'X');
      this.cardNumber = `${bin.substring(0, 4)} ${bin.substring(4, 6)}XX XXXX XXXX`;
    }

    // Show what has been typed so far and let the mask cover the rest, so the field fills in
    // place rather than flipping between a placeholder and a value.
    if (changes.cardExpiration) {
      const typed: string = changes.cardExpiration.currentValue || '';
      const mask = this.expirationMask();
      this.expiration = typed.length >= mask.length ? typed : typed + mask.slice(typed.length);
    }
  }
}
